export default __webpack_public_path__ + "static/media/2.a4c16d59.png";